export const OWNER_TICKET_SALE_TYPE = 'ticket-type';
export const OWNER_EVENT = 'event';
